import store from '../store';
import Items from '../views/ebay/Index.vue';
import Unmatched from '../views/marketplace/Unmatched.vue';
import PriceAnalysis from '../views/ebay/PriceAnalysis.vue';
import { checkauth } from '../Helper';
import marketplaceTools from './marketplaceTools';

export default [
	{
		path: '/ebay',
		name: 'ebay',
		component: Items,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/ebay/associa',
		name: 'ebay-unmatched',
		component: Unmatched,
		// stessa view di Amazon: la piattaforma arriva da qui
		meta: { platform: 'ebay' },
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/ebay/analisi-prezzi',
		name: 'ebay-price-analysis',
		component: PriceAnalysis,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	...marketplaceTools('ebay'),
];
